module.exports = __webpack_public_path__ + "static/media/x3_icon.29fe8c80.svg";